import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { useContent } from '../context/ContentContext';

export default function FinancingOverview() {
  const { content } = useContent();
  const d = content.financingOverview;

  return (
    <section className="bg-brand-off-white">
      <div className="max-w-site mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 lg:py-24">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <span className="inline-block text-brand-orange font-semibold text-sm uppercase tracking-wider mb-3">
              {d.sectionLabel}
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-[42px] lg:leading-[1.15] font-serif font-bold text-brand-navy mb-5">
              {d.heading}
            </h2>

            <p className="text-brand-warm-gray text-base sm:text-lg leading-relaxed mb-4">
              {d.description1}
            </p>
            <p className="text-brand-warm-gray text-base sm:text-lg leading-relaxed mb-8">
              {d.description2}
            </p>

            <div className="grid sm:grid-cols-2 gap-x-6 gap-y-3">
              {d.highlights.map((highlight) => (
                <div key={highlight} className="flex items-center gap-3">
                  <CheckCircleIcon className="w-5 h-5 text-brand-orange flex-shrink-0" />
                  <span className="text-brand-navy text-sm sm:text-[15px] font-medium">{highlight}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="grid grid-cols-2 gap-4">
              {d.stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-white border border-gray-100 rounded-2xl p-5 sm:p-6 text-center"
                >
                  <p className="text-3xl sm:text-4xl font-bold text-brand-orange mb-1">{stat.value}</p>
                  <p className="text-brand-warm-gray text-xs sm:text-sm uppercase tracking-wider font-medium">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="mt-6 bg-white border border-gray-100 rounded-2xl p-5 sm:p-6">
              <p className="text-brand-navy font-serif font-bold text-lg mb-2 text-center">
                {d.promiseHeading}
              </p>
              <p className="text-brand-warm-gray text-sm leading-relaxed text-center italic">
                &quot;{d.promiseText}&quot;
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
